///<reference path="../event/EventDispatcher.ts"/>
///<reference path="../event/Event.ts"/>
///<reference path="./URLLoader.ts"/>
///<reference path="./URLRequest.ts"/>

namespace com.enirva.net
{
	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Event = com.enirva.event.Event;
	
	export class MultipleLoader extends EventDispatcher
	{
		public data:any;
		
		public textRequests: Object;
		
		public isParallel:boolean;

		private percent: number;

		private loadIndex: number;

		private textRequestsArray: Array<string>;
		
		constructor()
		{
			super();
			
			this.percent = 0;
			this.loadIndex = 0;
			this.textRequests = {};
			this.textRequestsArray = [];
		}
		
		
		public addRequestURL(urls:Array<string>):void
		{
			for (var i:number = 0, ln:number = urls.length; i < ln; i++)
			{
				var url:string = urls[i];
				this.textRequests[url] = url;
				this.textRequestsArray.push(url);
			}
		}
		
		
		public load():void
		{
			if (this.isParallel)
			{
				if (this.textRequestsArray.length > 0)
				{
					for (var i:number = 0, ln:number = this.textRequestsArray.length; i < ln; i++)
					{
						this.loadTextParallel(i);
					}
				}
			}
			else
			{
				if (this.textRequestsArray.length > 0)
				{
					this.loadText();
				}
			}
		}
		
		
		// Single ////////////////////////////////////////////////////


		private loadText(): void
		{
			var scope: MultipleLoader = this;
			var url: string = this.textRequestsArray[this.loadIndex];
			
			var req:URLRequest = new URLRequest(url);
			var loader:URLLoader = new URLLoader();
			loader.addEventListener(Event.COMPLETE, function(e:Event):void
			{
				scope.completeHandler(url, loader.data);
			});
			loader.load(req);
		}
		

		private completeHandler(url: string, data:string): void
		{
			this.textRequests[url] = data;

			++this.loadIndex;
			
			var ln:number = this.textRequestsArray.length;

			this.percent = this.loadIndex / ln;

			if (this.loadIndex >= ln)
			{
				var evt:Event = new Event(Event.COMPLETE);
				this.dispatchEvent(evt);
			}
			else
			{
				this.loadText();
			}
		}
		
		
		// Parallel ////////////////////////////////////////////////////
		
		private loadTextParallel(index:number): void
		{
			var scope: MultipleLoader = this;
			var url: string = this.textRequestsArray[index];
			
			var req:URLRequest = new URLRequest(url);
			var loader:URLLoader = new URLLoader();
			loader.addEventListener(Event.COMPLETE, function(e:Event):void
			{
				scope.completeHandlerParallel(url, loader.data);
			});
			loader.load(req);
		}
		

		private completeHandlerParallel(url: string, data:string): void
		{
			this.textRequests[url] = data;

			++this.loadIndex;
			
			var ln:number = this.textRequestsArray.length;

			this.percent = this.loadIndex / ln;

			if (this.loadIndex >= ln)
			{
				var evt:Event = new Event(Event.COMPLETE);
				this.dispatchEvent(evt);
			}
		}
	}
}

